var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastLoadingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1821",
    "data-name": "Rectangle 1821",
    width: 37,
    height: 37,
    transform: "translate(-0.493 -0.493)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9019",
    "data-name": "Group 9019",
    transform: "translate(0.353 0.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9018",
    "data-name": "Group 9018",
    transform: "translate(0.14 0.14)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11564",
    "data-name": "Path 11564",
    d: "M17.824,36.147A18.328,18.328,0,0,1,10.691.94,18.319,18.319,0,0,1,36.147,17.824a1.5,1.5,0,0,1-3,0A15.324,15.324,0,0,0,6.988,6.988,15.324,15.324,0,0,0,17.824,33.147a1.5,1.5,0,0,1,0,3Z",
    transform: "translate(0.184 0.184)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11565",
    "data-name": "Path 11565",
    d: "M16.27,17.805a3.255,3.255,0,1,1-4.6-4.6c1.271-1.272,9.649-5.047,9.649-5.047S17.542,16.533,16.27,17.805Z",
    transform: "translate(3.543 2.658)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastLoadingLogo);
export default __webpack_public_path__ + "static/media/fastLoadingLogo.8cbe729f36ca2be33422b0b380afb551.svg";
export { ForwardRef as ReactComponent };